import { type OrderGetPaginatedOrdersOrderReadDtoStatusEnum } from "@/config/apiClient";
import { OrderStatusEnum } from "@/config/apiClient.types";

export const NEW_ORDER_KEY = "newOrder";
export const DRAFT_ORDERS_KEY = "draft";
export const IN_PROGRESS_ORDERS_KEY = "inProgress";
export const TO_STUDY_ORDERS_KEY = "toStudy";

export const VALID_ORDER_STATUSES: OrderGetPaginatedOrdersOrderReadDtoStatusEnum[] =
  [
    OrderStatusEnum.DRAFT,
    OrderStatusEnum.IN_PROGRESS,
    OrderStatusEnum.TO_STUDY,
  ];

export const CATEGORY_CONFIG = [
  { key: TO_STUDY_ORDERS_KEY, status: OrderStatusEnum.TO_STUDY },
  { key: DRAFT_ORDERS_KEY, status: OrderStatusEnum.DRAFT },
  { key: IN_PROGRESS_ORDERS_KEY, status: OrderStatusEnum.IN_PROGRESS },
];
